"use client";
import { motion } from "framer-motion";
import IMask from "imask";
import { useState, useEffect, useRef } from "react";
import { FaBuilding, FaEnvelope, FaWhatsapp } from "react-icons/fa";

import { formSchema } from "./form-schema";

const messages = ["Carregando a interface do Rota Lounge...", "Preparando tudo para você...", "Quase lá..."];

const LoadingScreen = () => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentMessageIndex((currentMessageIndex + 1) % messages.length);
    }, 3000);
    return () => clearInterval(intervalId);
  }, [currentMessageIndex]);
  return (
    <div className='fixed inset-0 z-50 bg-gray-100 flex flex-col justify-center items-center space-y-4'>
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
        className='border-t-4 border-b-4 border-purple-500 rounded-full w-16 h-16'
      ></motion.div>
      <motion.p
        key={currentMessageIndex}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.5 }}
        className='text-lg text-purple-600'
      >
        {messages[currentMessageIndex]}
      </motion.p>
    </div>
  );
};

const FormFreeTrial: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const celInputRef = useRef(null);
  useEffect(() => {
    if (celInputRef.current) {
      IMask(celInputRef.current, {
        mask: "(00)00000-0000",
      });
    }
  }, []);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsLoading(true);
    setError(null);
    const rawCel = event.currentTarget.cel.value;
    const normalizedCel = rawCel.replace(/\D/g, "");
    const formData = {
      business_name: event.currentTarget.business_name.value,
      email: event.currentTarget.email.value,
      cel: normalizedCel,
    };
    try {
      const validatedData = formSchema.parse(formData);
      const urlApp = "https://app.rotalounge.com.br"; // URL do seu app
      const urlApi = "https://srv615911.hstgr.cloud"; // URL da sua API
      const response = await fetch(urlApi + "/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          name: validatedData.business_name,
          email: validatedData.email,
          cel: formData.cel,
        }),
      });
      if (!response.ok) {
        const responseText = await response.text();
        if (response.status === 422) {
          const errorData = JSON.parse(responseText);
          const errorMessage = errorData.message || "Falha ao enviar os dados do formulário";
          throw new Error(errorMessage);
        } else {
          throw new Error(responseText || "Falha ao enviar os dados do formulário");
        }
      }
      const data = await response.json();
      console.log("Token armazenado:", data.token);
      window.location.href = urlApp + `/login?token=${data.token}`;
    } catch (error) {
      console.error("Erro no envio do formulário:", error);
      if (error instanceof Error) {
        setError(error.message);
      } else {
        setError("Erro desconhecido ao enviar o formulário.");
      }
      setIsLoading(false);
    }
  };
  return (
    <>
      {isLoading && <LoadingScreen />}
      <div className='bg-white p-6 md:p-10 rounded-lg shadow-md'>
        <h2 className='text-xl md:text-2xl font-bold mb-5 text-gray-900 text-center'>Experimente de Graça!</h2>
        <form className='space-y-6' onSubmit={handleSubmit}>
          <div className='relative'>
            <label htmlFor='business_name' className='block text-sm font-medium text-gray-900'>
              Nome da Empresa
            </label>
            <FaBuilding className='absolute left-3 top-8 text-gray-400 h-6 w-6' />
            <input
              type='text'
              id='business_name'
              className='pl-12 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5'
              required
            />
          </div>
          <div className='relative'>
            <label htmlFor='email' className='block text-sm font-medium text-gray-900'>
              Email
            </label>
            <FaEnvelope className='absolute left-3 top-8 text-gray-400 h-6 w-6' />
            <input
              type='email'
              id='email'
              className='pl-12 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5'
              required
            />
          </div>
          <div className='relative'>
            <label htmlFor='cel' className='block text-sm font-medium text-gray-900'>
              WhatsApp
            </label>
            <FaWhatsapp className='absolute left-3 top-8 text-gray-400 h-6 w-6' />
            <input
              type='text'
              id='cel'
              ref={celInputRef}
              className='pl-12 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full p-2.5'
              required
            />
          </div>
          <button
            type='submit'
            className='text-white bg-purple-700 hover:bg-purple-600 focus:ring-4 focus:ring-purple-300 font-medium rounded-lg text-sm px-5 py-2.5 w-full'
          >
            Iniciar
          </button>
          {error && <p className='text-red-500 text-center mt-4'>{error}</p>}
        </form>
      </div>
    </>
  );
};

export default FormFreeTrial;
